import { ADMIN as BASE } from "..";
import { CampaignMenu } from "./menu";

export const CAMPAIGNS = BASE.child("/campaigns");
export const CAMPAIGN = BASE.child("/campaigns/:campaignId", undefined, {
  components: { menu: CampaignMenu },
});
